export let accessableFeature = [];
export let isUnderMaintenance = [],
  appsUnderMaintenance = [];
export let isLoadingFeature = false;
import { useState, useEffect } from "react";
// import { user, getHasuraJwtToken } from "./auth";
import { graphql } from "./request";
import { pathOr, includes, findIndex, propEq } from "ramda";

export const getFeature = async (TeamID, CostcenterID) => {
  isLoadingFeature = true;
  try {
    if ((TeamID, CostcenterID)) {
      const response = await graphql(
        `
          query featureToggle(
            $teamid: Int
            $costcenterid: Int
            $appname: String
            $origin: String
            $id: Int
          ) {
            feature(
              where: {
                _or: [
                  {
                    costcenter_feature_toggles: {
                      costcenter_id: { _eq: $costcenterid }
                      _and: { is_deleted: { _eq: false } }
                    }
                  }
                  {
                    user_feature_toggles: {
                      team_id: { _eq: $teamid }
                      _and: { is_deleted: { _eq: false } }
                    }
                  }
                ]
                is_active: { _eq: true }
                is_deleted: { _eq: false }
              }
            ) {
              name
            }
            arc_maintenance_page {
              is_under_maintenance
              page_name
              id
              origin
            }
            myapplied_maintenance_page {
              id
              app_name
              is_under_maintenance
              origin
            }
          }
        `,
        {
          teamid: parseInt(TeamID),
          costcenterid: parseInt(CostcenterID),
        }
      );

      accessableFeature = pathOr([], ["data", "data", "feature"], response);
      isUnderMaintenance = pathOr(
        [],
        ["data", "data", "arc_maintenance_page"],
        response
      );
      appsUnderMaintenance = pathOr(
        [],
        ["data", "data", "myapplied_maintenance_page"],
        response
      );
      console.log(accessableFeature, appsUnderMaintenance);
    }
  } catch (e) {
    console.log("failed fetching feature");
  } finally {
    isLoadingFeature = false;
  }
};

export const useFeature = (feature = "", app = "") => {
  const [bool, setBool] = useState(
    includes({ name: feature.toLowerCase() }, accessableFeature)
  );
  const [underMaintenance, setUnderMaintenance] = useState(false);
  const [loading, setLoading] = useState(isLoadingFeature);

  useEffect(() => {
    const id = setInterval(() => {
      setBool(includes({ name: feature.toLowerCase() }, accessableFeature));
      setLoading(isLoadingFeature);

      if (app !== "") {
        const appIndex = findIndex(propEq("app_name", app))(
          appsUnderMaintenance
        );

        if (appIndex !== -1)
          setUnderMaintenance(
            appsUnderMaintenance?.[appIndex]?.["is_under_maintenance"]
          );
      }
    }, 1000 * 1);
    return () => {
      clearInterval(id);
    };
  }, [feature, accessableFeature, appsUnderMaintenance]);

  return app === "" ? bool : { feature: bool, underMaintenance, loading };
};

export const useArcFeature = (origin = {}) => {
  const [underMaintenanceARC, setUnderMaintenanceARC] = useState();
  const env = isUnderMaintenance.filter((el) => el.origin === origin);
  useEffect(() => {
    const id = setInterval(() => {
      setUnderMaintenanceARC(env?.[0]?.["is_under_maintenance"]);
    }, 1000 * 1);
    return () => {
      clearInterval(id);
    };
  }, [isUnderMaintenance]);
  return { underMaintenanceARC };
};
